module.exports = __webpack_public_path__ + "img/menu.dc12efaf.svg";